import React, { useState } from 'react'
import { BlockPicker } from 'react-color'
import classNames from 'classnames'
import { Svg } from '../../../../../components'
import styles from './ThemeSelector.module.scss'
import { $TSFixMe } from 'types/ts-migrate'
import { rgbaToHex } from 'utils/general'

type TProps = {
  themes: Array<{ name: string; color: string; fontColor: string }>
  currentTheme?: { name: string; color: string; fontColor: string }
  onChange?: (theme: any) => void
  error?: string
}

const ThemeSelector = ({ themes, currentTheme, onChange = (theme: any) => {}, error }: TProps) => {
  const [hexColor, setHexColor] = useState<string>(currentTheme ? currentTheme.color : '#fff')
  const classes = classNames(styles.root, {
    [styles['has-error']]: !!error,
  })
  return (
    <div className={classes}>
      <BlockPicker
        colors={themes.map((theme: any) => rgbaToHex(theme.color))}
        color={hexColor}
        onChange={(color: $TSFixMe) => {
          const matchingTheme = themes.filter((theme: any) => rgbaToHex(theme.color) === color.hex)
          currentTheme ? setHexColor(color.hex) : '#fff'
          onChange(
            matchingTheme[0]
              ? matchingTheme[0]
              : { name: 'Custom', color: color.hex, fontColor: '#000', primary: color.hex },
          )
        }}
      />
    </div>
  )
}

export default ThemeSelector
